export default "__VITE_ASSET__BXwhcu9K__"